


























import Enumerable from "linq";
import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { MultiSelectableMixin } from "./mixins";
import InfiniteLoading from "vue-infinite-loading";

@Component({
  components: {
    InfiniteLoading
  },
})
export default class MultiFlowLayoutSelector extends Mixins(MultiSelectableMixin) {
  @Prop({ default: 50 })
  loadChunkSize: number;

  infiniteRetryTimer: NodeJS.Timeout = null;
  chunkedCount: number = 0;
  loadedOptions: any[] = [];

  $refs!: {
    infiniteLoading: InfiniteLoading,
  };

  private pressed: boolean = false;
  private startIndex: number = -1;
  private activeIndex: number = -1;

  onInfinite(): void {
    clearTimeout(this.infiniteRetryTimer);
    this.chunkList();
  }

  private chunkList(): void {
    for (let i = this.chunkedCount; i < (this.chunkedCount + this.loadChunkSize); i++) {
      if (i >= this.filteredOptions.length) {
        this.chunkedCount = this.filteredOptions.length;
        this.$refs.infiniteLoading.stateChanger.complete();
        return;
      }
      this.loadedOptions.push(this.filteredOptions[i]);
    }
    this.chunkedCount += this.loadChunkSize;
    this.$refs.infiniteLoading.stateChanger.loaded();
  }

  private resetChunkList(): void {
    this.loadedOptions = [];
    this.chunkedCount = 0;
    if (this.$refs.infiniteLoading) {
      this.$refs.infiniteLoading.stateChanger.reset();
      this.infiniteRetryTimer = setTimeout(this.resetChunkList, 500);
    }
  }

  optionClass(option: any, index: number): string {
    return [
      Enumerable.from(this.selectedOptions).contains(option)
        ? "select"
        : null,
      this.pressed && Math.min(this.startIndex, this.activeIndex) <= index && index <= Math.max(this.startIndex, this.activeIndex)
        ? "selecting"
        : null,
    ].filter((v) => v).join(" ");
  }

  onMouseDown(event: PointerEvent, option: any, index: number): void {
    this.resetMouseStatus();
    this.pressed = true;
    this.startIndex = index;
    this.activeIndex = index;
  }

  onMouseMove(event: PointerEvent, option: any, index: number): void {
    if (event.buttons === 0) {
      this.resetMouseStatus();
      return;
    }
    this.activeIndex = index;
  }

  onMouseUp(event: PointerEvent, option: any, index: number): void {
    if (this.pressed) {
      const selected = Enumerable.from(this.selectedOptions).contains(option);
      const single = this.startIndex === index;
      if (single && event.ctrlKey) {
        // 部分選択
        this.selectedOptions = selected
          ? Enumerable.from(this.selectedOptions)
              .where(e => e !== option)
              .toArray()
          : this.selectedOptions.concat(option);  // 並び順考慮するならfilteredOptionsから絞りなおすべき？
      } else {
        // 範囲選択
        this.selectedOptions = selected && single
          ? []
          : Enumerable.from(this.filteredOptions)
              .skip(Math.min(this.startIndex, index))
              .take(Math.abs(this.startIndex - index) + 1)
              .toArray();
      }
    }
    this.resetMouseStatus();
  }

  private resetMouseStatus() {
    this.pressed = false;
    this.startIndex = -1;
    this.activeIndex = -1;
  }

  @Watch("filteredOptions")
  onFilteredOptionsUpdated(newValue: any[], oldValue: any[]): void {
    this.resetChunkList();

    // 選択状態を更新
    this.selectedOptions = Enumerable.from(this.selectedOptions)
      .where(o => this.optionFilter(o))
      .toArray();
  }
}
